export function getDayOfWeekName(dayOfWeek: number | undefined) {
    return !dayOfWeek || isNaN(dayOfWeek) ? null : ['Nedeľa', 'Pondelok', 'Utorok', 'Streda', 'Štvrtok', 'Piatok', 'Sobota'][dayOfWeek];
}


export function lookupNameFromObjectsArray(arr: Array<Record<string, any>>, key: string, value: number) {
    const found = arr.find(item => item[key] === value)
    if (found) {
        return found.name
    } else {
        return 'N/A'
    }
}



export function lookupFromObjectsArray(arr: Array<Record<string, any>>, key: string, value: number) {
    const found = arr.find(item => item[key] === value)
    return found
}


export const months = ['Január', 'Február', 'Marec', 'Apríl', 'Máj', 'Jún', 'Júl', 'August', 'September', 'Október', 'November', 'December']

export function lookupMonthName(month: any /*1-12*/) {
    if (Number.isInteger(month)) {
        return months[month - 1]
    } else {
        return months[(parseInt(month, 10) - 1)]
    }
}